module.exports = __webpack_public_path__ + "img/04.078150d3.jpg";